import angular from 'angular'

// components
import changePassword from './component/changePassword.component'

export default angular
  .module('portalApp.manageChangePassword', [])
  .component('changePassword', changePassword)
  .name
